// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"EditCommsMobileHeader_infoWrapper__3wY8f","commLabel":"EditCommsMobileHeader_commLabel__1YVBD"};